<template>
    <div>
        <div class="columns">
            <div class="column">
                <multiselect
                    v-model="form.user"
                    v-validate="'required'"
                    :options="users_list.data.results || []"
                    :loading="users_list.loading"
                    placeholder="Search user to select"
                    @search-change="search"
                    :custom-label="label"
                    select-label=""
                    track-by="id"
                    name="user"/>
                <p class="help is-danger">{{ errors.first('user') }}</p>
            </div>

            <div class="column is-narrow">
                <base-button
                    @click="submit"
                    :loading="create.loading"
                    class="is-primary add-button"
                    icon="fas fa-plus"
                    text="Add"/>
            </div>
        </div>

        <base-backend-errors :data="create.error"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Multiselect from 'vue-multiselect';

export default {
    components: { Multiselect },
    props: {
        team_id: { type: Number, default: null },
    },
    data() {
        return {
            form: { user: null },
        };
    },
    computed: {
        ...mapState('user', { users_list: 'list' }),
        ...mapState('team_members', ['create']),
    },
    methods: {
        label({ email, first_name, last_name }) {
            return `${first_name} ${last_name} (${email})`;
        },
        submit() {
            this.$validator.validate().then((result) => {
                if (!result) return;
                this.$store.dispatch('team_members/create', {
                    user: this.form.user.id,
                    team: this.team_id,
                }).then(() => {
                    this.$emit('created', this.form);
                    this.form.user = null;
                    this.$validator.reset();
                });
            });
        },
        search(query) {
            this.$store.dispatch('user/list', { search: query });
        },
    },
};
</script>

<style scoped>
    .add-button {
        font-size: 1.1rem;
    }
</style>
